// src/components/pages/CookiePolicy.js
import React from 'react';import './CookiePolicy.css'; // Create a CSS file for styling


const CookiePolicy = () => {
  return (
    <div>
        <h1 id='SpectoConsultHelp'>Cookie Policy</h1>
        <div id="flexContainer">
            <div className='box4'>
              <p>This Cookie Policy explains how Specto Consult uses cookies and similar technologies on our website. By using our Website, you consent to the use of cookies as described in this policy.</p>
              <br></br>
              <h2>1. What are Cookies?</h2>
              <p>Cookies are small text files that are stored on your computer or mobile device when you visit a website. They are widely used to make websites work more efficiently and to provide information to website owners.</p>
              <br></br>
              <h2>2. Types of Cookies We Use</h2>
              <ul>
                <li><strong>Essential Cookies:</strong> Necessary for the operation of our Website.</li>
                <li><strong>Analytical/Performance Cookies:</strong> Allow us to recognize and count the number of visitors and see how they navigate our Website.</li>
                <li><strong>Functionality Cookies:</strong> Recognize you when you return to our Website, enabling personalized content and preferences.</li>
                <li><strong>Targeting Cookies:</strong> Record your visit and personalize our Website and advertising based on your interests.</li>
              </ul>
              <br></br>
              <h2>3. Managing Cookies</h2>
              <p>You can manage cookies through your browser settings. Most browsers allow you to refuse or delete cookies. Please note that blocking cookies may affect your access to certain features of our Website.</p>
              <br></br>
              <h2>4. Changes to Our Cookie Policy</h2>
              <p>We may update this Cookie Policy to reflect changes in technology, legislation, or our data practices. Please review this policy periodically for updates.</p>
              <br></br>
              <h2>5. Contact Us</h2>
              <p>If you have questions about our use of cookies or this Cookie Policy, please contact us at <a href="mailto:flha@spectoconsult.com">flha@spectoconsult.com</a>.</p>
            </div>
        </div>
    </div>

  );
};

export default CookiePolicy;
